<template>
  <div class="ms-container full-width">
    <contract-editor />
  </div>
</template>

<script>
import ContractEditor from '@/components/contract-editor/contract-editor'

export default {
  components: {
    ContractEditor
  }
}
</script>

<style>
</style>
